import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Page from "./components/Page.vue";
import Gap from "./components/base/Gap.vue";
import "./styles/common.scss";
import "./styles/animation.scss";
import "vant/es/toast/style";

import "vant/lib/index.css";
import { setupStore } from "./store";
import { setupDirective } from "./directive";
import { setupWebTrack } from "@/hooks/useTracker";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  init,
  // initDocHeight
} from "./utils/initUtil";
import { Notify } from "vant";
import { initPwa } from "@/utils/pwaGuide/pwaGuide";
import Mixins from "./mixins/global";
import { setupI18n } from "./lang";
// import vconsole from "vconsole";

const requireContext = require.context("./assets/icons", false, /\.svg$/);
requireContext.keys().forEach(requireContext);
dayjs.extend(utc);
dayjs.extend(timezone);
const app = createApp(App);

setupWebTrack(app);
setupStore(app);
setupI18n(app);
setupDirective(app);

app.use(Notify);
app.component("Page", Page).component("Gap", Gap).use(router);
// // use vconsole
// const vConsole = new vconsole();
// app.use(vConsole);

// 初始化Android 安装提示
initPwa("android");

init().finally(() => {
  // initDocHeight();
  // 初始化iOS 安装提示
  initPwa("ios");
  app.mount("#app");
  document.getElementById("loading")?.remove();
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js");
}
app.mixin(Mixins);
